var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 50,
    height: 50,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(-1938 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(1938 35)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 46.875,
    height: 46.875,
    rx: 4.5,
    transform: "translate(1.563 1.563)",
    fill: "#e3e3e3",
    stroke: "#e3e3e3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght400_GRAD0_opsz48",
    d: "M208.438,321.7,207,320.261l7.911-7.911L207,304.438,208.438,303l7.911,7.911L224.261,303l1.438,1.438-7.911,7.911,7.911,7.911-1.438,1.438-7.911-7.911Z",
    transform: "translate(-191.349 -287.35)",
    fill: "#5d5b5c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitMark);
export default __webpack_public_path__ + "static/media/exit_mark.664218af45b3a2c72a12c5fbe95dc2dc.svg";
export { ForwardRef as ReactComponent };